import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=56f0d5c2&"
import script from "./Alert.vue?vue&type=script&lang=ts&"
export * from "./Alert.vue?vue&type=script&lang=ts&"
import style0 from "./Alert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f0d5c2')) {
      api.createRecord('56f0d5c2', component.options)
    } else {
      api.reload('56f0d5c2', component.options)
    }
    module.hot.accept("./Alert.vue?vue&type=template&id=56f0d5c2&", function () {
      api.rerender('56f0d5c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/Alert.vue"
export default component.exports